import moment from 'moment';

export const dateIsNewerThan = (date, days) => {
  const now = moment(new Date());
  return now.diff(date, 'days') <= days;
};
